import React, { Component, ErrorInfo, ReactNode } from 'react';

// Fungsi untuk melaporkan ralat
const reportError = (error: Error, errorInfo: ErrorInfo): void => {
  console.error('ErrorBoundary caught an error:', error, errorInfo);
  // Di sini anda boleh menambah kod untuk menghantar ralat ke perkhidmatan pemantauan seperti Sentry
};

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    // Replace console.error with the reporting function
    reportError(error, errorInfo);
  }

  render(): ReactNode {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return this.props.fallback;
      }

      return (
        <div className="p-6 max-w-md mx-auto bg-white rounded-xl shadow-md flex flex-col items-center space-y-4 mt-10">
          <div className="text-red-500 text-4xl">⚠️</div>
          <h2 className="text-xl font-medium text-red-600">Oops, something went wrong</h2>
          <p className="text-gray-600 text-center">
            The application encountered an unexpected error. Please try refreshing the page or contact support if the issue persists.
          </p>
          <pre className="bg-gray-100 p-3 rounded text-sm overflow-auto max-w-full">
            {this.state.error?.message}
          </pre>
          <button
            onClick={() => window.location.reload()}
            className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            Refresh Page
          </button>
        </div>
      );
    }

    return this.props.children;
  }
} 